import React, { useRef } from 'react'
import UploadIcon from 'images/inline/ugc-video/upload.svg'
import { useTranslation } from 'i18n'
const UploadButton = ({
  onFileSelection = function () {},
  label,
  mediaAccepted = [`image/*`, 'video/*'],
}) => {
  const { t } = useTranslation('ugcMediaUpload')
  const handleFileUpload = event => {
   // console.log(event.target.files)
   // let files = event.target.files.map(file => {
   //   return {
  //      name: "effdf",
  //      ...file
   //   }
  //  })
    onFileSelection(event.target.files)
  }
  const inputElement = useRef()
  return (
    <div className={`receipt-upload-button`}>
      <React.Fragment>
        <input
          ref={inputElement}
          onChange={handleFileUpload}
          type="file"
          style={{ display: 'none' }}
          multiple={false}
          accept={mediaAccepted.join(', ')}
        />
        <button
          className={'btn upload-button'}
          onClick={() => inputElement.current.click()}
        >
          <UploadIcon />
          {label || t('upload.uploadFile')}
        </button>
      </React.Fragment>
    </div>
  )
}

export default UploadButton
